/*
    Created by Phat Hoang Pham
    phat@launchdeck.org
*/

import React, { PureComponent } from 'react';
import { Text, View } from 'react-native-web';
import PropTypes from 'prop-types';
import Icon from 'react-native-vector-icons/dist/MaterialIcons';

import GLOBAL from '../configs/config_global';

export class SceneCateringTagItem extends PureComponent {
    // region Props
    static propTypes = {
        text: PropTypes.string,
        backgroundColor: PropTypes.string,
        textColor: PropTypes.string,
        textSize: PropTypes.number,
        textWeight: PropTypes.string,
        style: PropTypes.object
    };

    static defaultProps = {
        text: 'Tag',
        backgroundColor: GLOBAL.COLOR.BASIC.NEUTRAL_GREY,
        textColor: 'white',
        textSize: 14,
        textWeight: 'bold',
        style: {}
    };
    // endregion

    // region Functions

    // endregion

    // region MAIN RENDER FUNCTION
    render() {
        const {
            text,
            backgroundColor,
            textColor,
            textSize,
            textWeight,
            iconName
        } = this.props;

        return(
            <View style={[{ flexDirection: 'row', alignItems: 'center', paddingVertical: 6, paddingHorizontal: 12, backgroundColor: backgroundColor, borderRadius: 6, marginTop: 6, alignSelf: 'flex-start', marginRight: 8 }].concat(this.props.style)}>
                {!!iconName && <Icon name={iconName} size={24} color={textColor} />}

                <Text style={{ color: textColor, fontSize: textSize, fontWeight: textWeight, marginLeft: iconName ? 8 : 0 }}>
                    {text}
                </Text>
            </View>
        );
    }
    // endregion
}
